<template>
  <div
    v-if="data"
    class="profilePage"
  >
    <header class="profileHeader">
      <button
        type="button"
        class="profileBack"
        :aria-label="$t('memberList.back')"
        @click="$router.back()"
      >
        <span aria-hidden="true" />
      </button>
      <h1>{{ data.name }}</h1>
    </header>

    <main class="profileContent">
      <section class="profileCard">
        <div class="profileVerification">
          <span class="profileVerificationTag">{{ $t('profileVerification.identity') }}</span>
          <span class="profileVerificationTag">{{ $t('profileVerification.video') }}</span>
        </div>
        <div class="profileIdentity">
          <h2>{{ data.name }}</h2>
          <div class="profileFacts">
            <span v-if="data.height">{{ $t('sky.height') }}: {{ data.height }}cm</span>
            <span v-if="data.xiong">{{ $t('sky.high') }}: {{ data.xiong }}</span>
          </div>
        </div>

        <div
          v-if="data.keys.length"
          class="profileTags"
        >
          <span
            v-for="(tag, index) in data.keys.slice(0, 4)"
            :key="index"
            class="profileTag"
            :class="'profileTag' + index"
          >{{ tag }}</span>
        </div>

        <div class="profileMetric">
          <span class="profileMetricLabel">{{ $t('sky.experienceSatisfaction') }}</span>
          <span class="profileStars">★★★★★</span>
        </div>
        <div class="profileMetric">
          <span class="profileMetricLabel">{{ $t('sky.addr') }}:</span>
          <span>{{ $t('memberList.within3km') }}</span>
        </div>

        <div class="profileActions">
          <button
            type="button"
            class="profileLike"
            @click="dianzan()"
          >
            <img
              src="../images/home/zan.png"
              alt=""
            >
            <span>{{ data.zan || 0 }}</span>
          </button>
       <!--   <button
            type="button"
            class="profileAppointment"
            @click="yuyue()"
          >
            {{ $t('sky.yuenow') }}
          </button> -->
        </div>
      </section>

      <section class="datingInstructions">
        <h2>{{ $t('datingInstructions.title') }}</h2>
        <p>{{ $t('datingInstructions.note') }}</p>
      </section>

      <section class="profileGallery">
        <article
          v-for="(image, index) in profileImages"
          :key="image + '-' + index"
          class="profileMedia"
        >
          <img
            :src="image"
            :alt="data.name"
          >
        </article>
        <div
          v-if="!profileImages.length"
          class="profileMedia profileMediaPlaceholder"
        />
      </section>
    </main>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
  name: "Vprofile",
  data() {
    return {
      data: null,
      imgs: [],
      yizan: false
    };
  },
  computed: {
    profileImages() {
      if (this.imgs.length) {
        return this.imgs.map((imagePath) => this.imageUrl(imagePath));
      }

      return this.data && this.data.pic ? [this.imageUrl(this.data.pic)] : [];
    }
  },
  created() {
    this.$parent.footer("girl", true);
  },
  mounted() {
    this.start();
  },
  methods: {
    yuyue() {
		// this.$router.push('/kefu' );
      // this.$toast(this.$t("sky.jihuo"));
    },
    dianzan() {
      if (this.yizan) {
        this.data.zan = Number(this.data.zan || 0) - 1;
        this.yizan = false;
        return;
      }

      this.data.zan = Number(this.data.zan || 0) + 1;
      this.yizan = true;
    },
    imageUrl(imagePath) {
      if (!imagePath || /^(?:https?:)?\/\//.test(imagePath)) {
        return imagePath;
      }

      return "https://imgs.clubvelvet.site" + (imagePath.charAt(0) === "/" ? imagePath : "/" + imagePath);
    },
    start() {
      Fetch("/index/girl", {
        id: this.$router.history.current.params.code
      }).then((res) => {
        const girl = res && res.data && res.data.girl;

        if (!girl || typeof girl !== "object") {
          this.data = null;
          this.imgs = [];
          return;
        }

        const keys = typeof girl.keystr === "string" && girl.keystr
          ? girl.keystr.split("|").filter((item) => item)
          : [];
        const images = typeof girl.imgs === "string" && girl.imgs
          ? girl.imgs.split("|").filter((item) => item)
          : [];

        this.data = Object.assign({}, girl, { keys });
        this.imgs = images;
      }).catch(() => {
        this.data = null;
        this.imgs = [];
      });
    }
  }
};
</script>

<style lang="less" scoped>
.profilePage {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 12px 18px 72px;
  background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
}

.profileHeader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}

.profileHeader h1 {
  margin: 0;
  color: #111;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.profileBack {
  position: absolute;
  top: 50%;
  left: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  transform: translateY(-50%);
}

.profileBack span {
  position: absolute;
  top: 7px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #121212;
  border-left: 1px solid #121212;
  transform: rotate(45deg);
}

.profileContent {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;
}

.profileGallery {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.profileCard,
.datingInstructions,
.profileMedia {
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
}

.profileCard,
.datingInstructions {
  padding: 14px;
}

.profileCard {
  position: relative;
}

.profileVerification {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.profileVerificationTag {
  height: 20px;
  padding: 0 7px;
  border-radius: 5px;
	background: linear-gradient(180deg,#e7caaf,#fff7ed);
	color: #a4826b;
  font-size: 10px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

.profileIdentity {
  margin-bottom: 10px;
}

.profileIdentity h2 {
  margin: 0 0 6px;
  color: #111;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.profileFacts {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  color: #606060;
  font-size: 12px;
  line-height: 18px;
}

.profileTags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.profileTag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border-radius: 5px;
  color: #fff;
  font-size: 10px;
  line-height: 20px;
}

.profileTag0 {
  background: #f8328c;
}

.profileTag1 {
  background: #8c64cf;
}

.profileTag2 {
  background: #e88957;
}

.profileTag3 {
  background: #5b8cc9;
}

.profileMetric {
  display: flex;
  align-items: center;
  min-height: 24px;
  color: #3c3157;
  font-size: 12px;
  line-height: 18px;
}

.profileMetricLabel {
  margin-right: 5px;
  color: #111;
}

.profileStars {
  color: #ffc719;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 18px;
}

.profileActions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.profileLike {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 9px;
  border: 0;
  border-radius: 15px;
  background: #fff3f8;
  color: #f8328c;
  font-size: 12px;
  line-height: 30px;
}

.profileLike img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.profileAppointment {
  flex: 1;
  height: 30px;
  padding: 0 10px;
  overflow: hidden;
  border: 0;
  border-radius: 15px;
  background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
  color: #fff;
  font-size: 12px;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.datingInstructions h2 {
  margin: 0 0 8px;
  color: #111;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.datingInstructions p {
  margin: 0;
  color: #606060;
  font-size: 12px;
  line-height: 18px;
  overflow-wrap: break-word;
  word-break: normal;
}

.profileMedia {
  overflow: hidden;
  border-radius: 10px;
  min-height: 220px;
  background: #f2f2f2;
}

.profileMedia img {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
}

.profileMediaPlaceholder {
  aspect-ratio: 3 / 4;
  background: #f2f2f2;
}
</style>
